import {Money, formatDateLocalized, formatNIS} from '@sollapay/utils';
import {resolvePayoutPayeeDisplayName} from '@sollapay/web-core';

import {
  resolveAuthorityDisplayName,
  resolvePayoutDescription,
  resolvePayoutRoleLabel
} from '@/features/payouts';

import type {PayoutInstructionDTO} from '@sollapay/types';
import type {ExportColumn} from '@sollapay/web-core';
import type {TFunction} from 'i18next';

export function createPayoutExportColumns(
  t: TFunction,
  language: string
): ExportColumn<PayoutInstructionDTO>[] {
  return [
    {
      header: t('view.payouts.list.columns.beneficiary'),
      value: row => resolvePayoutPayeeDisplayName(row.creditor, resolveAuthorityDisplayName)
    },
    {
      header: t('view.payouts.list.columns.role'),
      value: row => resolvePayoutRoleLabel(row.creditor, t)
    },
    {
      header: t('view.payouts.list.columns.purpose'),
      value: row => resolvePayoutDescription(row.creditor, t)
    },
    {
      header: t('view.payouts.list.columns.amount'),
      value: row => formatNIS(row.amount),
      rawValue: row => Money.from(row.amount).toNumber()
    },
    {
      header: t('view.payouts.list.columns.reference'),
      value: row => row.referenceCode
    },
    {
      header: t('view.payouts.list.columns.transferType'),
      value: row =>
        row.transferType ? t(`view.payouts.list.transferTypes.${row.transferType}`) : ''
    },
    {
      header: t('view.payouts.list.columns.status'),
      value: row => t(`view.payouts.list.status.${row.status}`)
    },
    {
      header: t('view.payouts.list.columns.createdAt'),
      value: row => formatDateLocalized(row.createdAt, language)
    }
  ];
}
